import * as actionTypes from "./actionTypes";
import * as types from "./types";

// GET access control 
const initialState: types.IAccessControlState = {
    pending: false,
    accessControls: [],
    error: null,
};

export const AccessControlReducer = (state = initialState, action: types.AccessControlActions) => {
    switch (action.type) {
        case actionTypes.FETCH_ACCESSCONTROL_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_ACCESSCONTROL_SUCCESS:
            return {
                ...state,
                pending: false,
                accessControls: action.payload.accessControls,
                error: null,
            };
        case actionTypes.FETCH_ACCESSCONTROL_FAILURE:
            return {
                ...state,
                pending: false,
                accessControls: [],
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

// GET Sources 

const initSourcesListState: types.SourceListState = {
    pending: false,
    sources: {} as types.IDataSourceList,
    error: null,
};

export const SourcesListReducer = (state = initSourcesListState, action: types.SourcesActions) => {
    switch (action.type) {
        case actionTypes.FETCH_SOURCES_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_SOURCES_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                sources: action.payload.sources,
                error: null,
            };
        case actionTypes.FETCH_SOURCES_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                sources: {} as types.IDataSourceList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

// GET Source Details

const initSourceState: types.SourceState = {
    pending: false,
    source: null,
    error: null,
};

export const SourceDetailsReducer = (state = initSourceState, action: types.SourceActions) => {
    switch (action.type) {
        case actionTypes.FETCH_SOURCE_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_SOURCE_SUCCESS:
            return {
                ...state,
                pending: false,
                source: action.payload.source,
                error: null,
            };
        case actionTypes.FETCH_SOURCE_FAILURE:
            return {
                ...state,
                pending: false,
                source: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


// DELETE Source Details

const initDeleteSourceState: types.IDeleteDataSourceState = {
    pending: false,
    success: null,
    error: null,
};

export const DeleteSourceReducer = (state = initDeleteSourceState, action: types.DeleteDataSourceActions) => {
    switch (action.type) {
        case actionTypes.DELETE_SOURCE_REQUEST:
            return {
                ...state,
                success: null,
                pending: true,
            };
        case actionTypes.DELETE_SOURCE_SUCCESS:
            return {
                ...state,
                pending: false,
                success: action.success,
                error: null,
            };
        case actionTypes.DELETE_SOURCE_FAILURE:
            return {
                ...state,
                pending: false,
                success: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


// POST Data Source

const initialStateDataSource: types.IPostDataSourceState = {
    pending: false,
    dataSource: null,
    error: null,
};

export const PostDataSourceReducer = (state = initialStateDataSource, action: types.PostDataSourceActions) => {

    switch (action.type) {
        case actionTypes.POST_DATASOURCE_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_DATASOURCE_SUCCESS:
            return {
                ...state,
                pending: false,
                dataSource: action.payload.dataSource,
                error: null,
            };
        case actionTypes.POST_DATASOURCE_FAILURE:
            return {
                ...state,
                pending: false,
                dataSource: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};


// PUT DATA SOURCE

const initialStatePutDataSource: types.IPutDataSourceState = {
    pending: false,
    dataSource: null,
    error: null,
};

export const PutDataSourceReducer = (state = initialStatePutDataSource, action: types.PutDataSourceActions) => {
    switch (action.type) {

        case actionTypes.PUT_DATASOURCE_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.PUT_DATASOURCE_SUCCESS:
            return {
                ...state,
                pending: false,
                dataSource: action.payload.dataSource,
                error: null,
            };
        case actionTypes.PUT_DATASOURCE_FAILURE:
            return {
                ...state,
                pending: false,
                dataSource: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};


// POST CONNECTION

const initialStateConnection: types.IPostConnectionState = {
    pending: false,
    succeeded: null,
    error: null,
};

export const PostConnectionReducer = (state = initialStateConnection, action: types.PostConnectionActions) => {

    switch (action.type) {
        case actionTypes.POST_CONNECTION_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_CONNECTION_RESET:
            return {
                ...state,
                pending: false,
                succeeded: null,
                error: null,
            };
        case actionTypes.POST_CONNECTION_SUCCESS:
            return {
                ...state,
                pending: false,
                succeeded: action.payload.succeeded,
                error: null,
            };
        case actionTypes.POST_CONNECTION_FAILURE:
            return {
                ...state,
                pending: false,
                succeeded: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }

};

// GET User: Data Stewards

const initialStateSteward: types.IStewardState = {
    pending: false,
    userName: [],
    error: null,
};

export const StewardReducer = (state = initialStateSteward, action: types.StewardActions) => {
    switch (action.type) {
        case actionTypes.FETCH_STEWARD_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_STEWARD_SUCCESS:
            return {
                ...state,
                pending: false,
                userName: action.payload.userName,
                error: null,
            };
        case actionTypes.FETCH_STEWARD_FAILURE:
            return {
                ...state,
                pending: false,
                userName: [],
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};




